import apiClient from '../axiosInstance';
import { API_BASE_ADDRESS } from '../api';

const scheduleService = (action: any) => {
  return {
    getSchedule: () =>
      apiClient.post(`${API_BASE_ADDRESS}/mypage/yoyaku/schedule-search`, {
        clubCode: action.clubCode == null ? '' : String(action.clubCode),
        imageDate: action.imageDate == null ? '' : String(action.imageDate),
        programId: action.programId == null ? '' : String(action.programId),
        memberId: action.memberId == null ? '' : String(action.memberId),
        contractDataList: action.contractDataList == null ? '' : String(action.contractDataList),
      }),
    getReserveConfirmData: () =>
      apiClient.get(
        `${API_BASE_ADDRESS}/mypage/yoyaku/contents-reservation?contentsId=${action.contentsId}&memberId=${action.memberId}&clubId=${action.clubId}&contentsDate=${action.contentsDate}&startTime=${action.startTime}&endTime=${action.endTime}`,
      ),
    postScheduleReservation: () => {
      const url = `${API_BASE_ADDRESS}/mypage/yoyaku/reservation-insert`;
      const payload = action.payload || {};
      return apiClient.post(url, payload);
    },
    postScheduleCancelWait: () => {
      const url = `${API_BASE_ADDRESS}/mypage/yoyaku/cancelwait-insert`;
      const payload = action.payload || {};
      return apiClient.post(url, payload);
    },
  };
};

export default scheduleService;
